import React, { useEffect, useState, useRef ,useMemo } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {  faChevronDown, faImage, faPaperclip, faPlus, faPlusCircle, faTrash, faX ,faSearch} from '@fortawesome/free-solid-svg-icons';
import {Loader} from '../Loader/Loader';
import { FaRegTrashAlt } from 'react-icons/fa';
import { Spinner } from '../Loader/Loader';
import { Msg200or201, Msg204, Msg400, Msg401 ,Msg403, Msg500 } from '../Messages/Messages';
import { useLocation, useNavigate } from 'react-router-dom';
import  '../Css/Tooltip.css';
import Search from '../Components/Search';
import useAutoScroll from '../Components/UseAutoScroll';
import { decryptData } from '../../utils/storageCrypto';

 
const useOutsideClick = (ref, callback) => {
  const handleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };

  React.useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);
};


const CustomDropdown = ({ options, selected, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  useOutsideClick(dropdownRef, () => setIsOpen(false));

  const handleOptionClick = (value) => {
    onSelect(value);
    setIsOpen(false);
  };


  return (
    <div className="relative w-1/6" ref={dropdownRef}>
    <div
      className="flex justify-between items-center p-2 border bg-white border-gray-300 rounded-md cursor-pointer"
      onClick={() => setIsOpen(!isOpen)}
    >
      <span className={`text-sm ${selected ? 'text-black' : 'text-[#838195]'}`}>
        {selected || 'Salu'}
      </span>
      <FontAwesomeIcon icon={faChevronDown} className="w-3 h-3 text-gray-500" />
    </div>
    {isOpen && (
      <div className="absolute mt-1 w-full h-40 bg-white border border-gray-300 rounded-md shadow-lg z-10 flex flex-col">
        <div className="overflow-y-auto scrollbar-visible flex-grow">
          {options.map((option) => (
            option.value !== 'add-new' && (
              <div className='p-1'>

              <div

                key={option.value}

                className="py-2 pl-1 cursor-pointer text-sm hover:bg-blue-500 hover:rounded-md  hover:text-white"

                onClick={() => handleOptionClick(option.value)}

              >

                {option.icon && <FontAwesomeIcon icon={option.icon} className="" />}

                {option.label}

              </div>

              </div>

            )

          ))}

        </div>

      </div>

    )}

  </div>

  

  );

};

const ViewProductDetails = () => {
    const navigate= useNavigate();
    const [productCategories, setProductCategories] = useState([
      ]);
      const [products, setProducts] = useState([
      ]);
      const [productAttributes, setProductAttributes] = useState([
      ]);
      
      const [productSubcategories, setProductSubcategories] = useState([
      ]);
   const location= useLocation();
   const { ItemData } = location.state || {};
  const [selectedProductCategory, setSelectedProductcategory] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productGroupid , setproductid] = useState(null);
  const backendApiUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const url = process.env.REACT_APP_FORE_BRICKBUCKET
  const [isLoading, setIsLoading] = useState(true);
  const imageUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupType, setPopupType] = useState('');
  const [errorMessages, setErrorMessages] = useState([]);
  const [vendor , setvendor] = useState()
  const [productCategory , setProductCategory] = useState()
  const [productGroup , setProductgroup] = useState()
   const [specifications, setSpecifications] = useState([]);
   const [productData, setproductData] = useState();
  const [showRequiredPopup, setShowRequiredPopup] = useState(false)
 // const [attributeLoading , setProductgrouploading]= useState(true)
  const [isSaving, setIsSaving] = useState(false);
  const [ProductLoader, setProductLoader] = useState(true)
  const RETRY_LIMIT = 3; // Maximum number of retries
  const [retryCount, setRetryCount] = useState(0); // Track retry attempts
  const [retryFunction, setRetryFunction] = useState(null);
  const [imageSrc, setImageSrc] = useState('');
const [isUploading, setIsUploading] = useState(false);
const [roleId, setRoleId] = useState(null);
const [showQuantityPricingPopup, setShowQuantityPricingPopup] = useState(false);
const [quantityPricingRows, setQuantityPricingRows] = useState([
  { minQuantity: '', maxQuantity: '', sellingPrice: '', costPrice: '' }
]);
const [productMoqsData, setProductMoqsData] = useState({});
const [searches, setSearches] = useState([]);

const searchTypes = [
  'Item Name',
  'Vendors',
  'Item Category',
  'Item Sub Category',
  'Item Group',
];

const [searchQuery, setSearchQuery] = useState('');  
const [searchType, setSearchType] = useState('');  
const itemRefs = useRef({});
const listContainerRef = useRef(null);



const itemsToDisplay = useMemo(() => {
  let list = roleId === 6
    ? products.filter(
        item =>
          item.product_category_id?.product_category_name
            ?.toLowerCase() === 'tiles'
      )
    : products;

  // New: Simple single-filter logic instead of multi-search array
  if (searchQuery && searchType) {
    const q = searchQuery.toLowerCase();
    const type = searchType.toLowerCase();

    list = list.filter(item => {
      switch (type) {
        case 'item name':
          return item?.product_name?.toLowerCase().includes(q);
        case 'vendors':
          return item?.vendor_id?.name?.toLowerCase().includes(q);
        case 'item category':
          return item?.product_category_id?.product_category_name
            ?.toLowerCase()
            .includes(q);
        case 'item sub category':
          return item?.product_sub_category_id?.product_sub_category_name
            ?.toLowerCase()
            .includes(q);
        case 'item group':
          return item?.product_group_id?.product_group_name
            ?.toLowerCase()
            .includes(q);
        default:
          return true;
      }
    });
  }

  return list;
}, [products, searchQuery, searchType, roleId]);  


useAutoScroll({
  selectedItem: selectedProduct,
  itemRefs,
  containerRef: listContainerRef,
});


/* useEffect(() => {
  if (selectedProduct && selectedProduct.product_image) {
    setImageSrc(imageUrl + selectedProduct.product_image);
  }
}, [selectedProduct, imageUrl]); */


/* const handleImageChange = async (event) => {
  const file = event.target.files[0];
  if (file) {
    const formData = new FormData();
    formData.append('image', file); // This should match the field name in Multer's configuration
    formData.append('_id', selectedProduct._id);

    setIsUploading(true);

    try {
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}product/change-product-image`, {
        method: 'PUT',
        headers: {
          'x-token': token,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (data.status === 200) {

        setImageSrc(imageUrl + data.data.product_image); // Update the image URL with the new uploaded image URL
        fetchItems(data.data)
      } else {
        console.error('Failed to upload image:', data.message || 'Unknown error');
      }
    } catch (error) {
      console.error('Error uploading image:', error);
    } finally {
      setIsUploading(false);
    }
  }
}; */




const handleImageChange = async (event) => {
  const file = event.target.files[0];
  if (file) {
    const formData = new FormData();
    formData.append('image', file); // This should match the field name in Multer's configuration
    formData.append('_id', selectedProduct._id);

    setIsUploading(true);

    try {
          const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);

      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}product/change-product-image`, {
        method: 'PUT',
        headers: {
          'x-token': token,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (data.status === 200) {

        setImageSrc(imageUrl + data.data.product_image); // Update the image URL with the new uploaded image URL
        fetchItems(data.data)
      } else {
        console.error('Failed to upload image:', data.message || 'Unknown error');
      }
    } catch (error) {
      console.error('Error uploading image:', error);
    } finally {
      setIsUploading(false);
    }
  }
};

const handleDragOver = (e) => {
  e.preventDefault();
  e.stopPropagation();
  // Optional: Add visual feedback for drag over
  e.currentTarget.classList.add('border-blue-500', 'bg-blue-50');
};

const handleDragLeave = (e) => {
  e.preventDefault();
  e.stopPropagation();
  // Remove visual feedback
  e.currentTarget.classList.remove('border-blue-500', 'bg-blue-50');
};

const handleDrop = async (e) => {
  e.preventDefault();
  e.stopPropagation();
  
  // Remove visual feedback
  e.currentTarget.classList.remove('border-blue-500', 'bg-blue-50');
  
  const files = e.dataTransfer.files;
  if (files.length > 0) {
    const file = files[0];
    
    // Check if it's an image file
    if (file.type.startsWith('image/')) {
      const formData = new FormData();
      formData.append('image', file);
      formData.append('_id', selectedProduct._id);

      setIsUploading(true);

      try {
            const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

        const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}product/change-product-image`, {
          method: 'PUT',
          headers: {
            'x-token': token,
          },
          body: formData,
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        if (data.status === 200) {
          setImageSrc(imageUrl + data.data.product_image);
          fetchItems(data.data);
        } else {
          console.error('Failed to upload image:', data.message || 'Unknown error');
        }
      } catch (error) {
        console.error('Error uploading image:', error);
      } finally {
        setIsUploading(false);
      }
    } else {
      // Optional: Show error message for non-image files
      alert('Please select an image file');
    }
  }
};


const handleFileInputClick = () => {
  document.getElementById('imageInput').click();
};

/*   useEffect(() => {
    const fetchProductCategories = async () => {
        try {
            const token = sessionStorage.getItem('token');
            const response = await fetch(url + "product-category/get-all-productCategories", {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-token':token
                }
            });
            const data = await response.json();
            if (response.ok) {
                setProductCategories(data); // Update customers state
            } else {
                console.error(data.message);
            }
        } catch (error) {
            console.error(error);
        }
    }
    fetchProductCategories();
}, []); */

/* useEffect(() => {
    const fetchItems = async () => {
        try {
            const token = sessionStorage.getItem('token');
            const response = await fetch(process.env.REACT_APP_FORE_BRICKBUCKET + "product-groups/get-all-products", {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-token':token
                }
            });
            const data = await response.json();
            if (response.ok) {
                setProducts(data); // Update ItemGroups state
            } else {
                console.error(data.message);
            }
        } catch (error) {
            console.error(error);
        }finally {
          setIsLoading(false);
        }
    }
    fetchItems();
}, []); */

useEffect(() => {
  fetchRoleId();
  fetchItems(ItemData);
  //setImageSrc(imageUrl + ItemData.product_image)
}, [ItemData]);



const fetchRoleId = () => {
  const encryptedroleId = sessionStorage.getItem('roleId');
  const sroleId = decryptData(encryptedroleId);
  setRoleId(sroleId);
};

const fetchItems = async (selectedItem,attempt = 1) => {
  try {
       const encryptedToken = sessionStorage.getItem('token');
           const token = decryptData(encryptedToken);
           const encryptedOrganizationId = sessionStorage.getItem('organizationId');
           const organizationId = decryptData(encryptedOrganizationId);
    const response = await fetch(process.env.REACT_APP_FORE_BRICKBUCKET + `product/get-all-products?organizationId=${organizationId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      }
    });
    const data = await response.json();
    if (data.status === 200 || data.status === 201 || data.status === 204) {
      setProducts(data.data);

      const findLatestItem = data.data.find(p => 
        p && p._id && selectedItem && selectedItem._id 
        ? p._id === selectedItem._id 
        : false
      );
  
      // Conditional updates with fallback
      if (findLatestItem) {
        setSelectedProduct(findLatestItem);

        handleProductClick(findLatestItem);
      } else {
         setSelectedProduct(selectedItem);
          handleProductClick(selectedItem);
      }
    } else if (data.status === 400) {
      setShowPopup(true);
      setPopupType('400');
      setPopupMessage('Bad Request!');
    } else if (data.status === 401) {
      setShowPopup(true);
      setPopupType('401');
      setPopupMessage('Unauthorized!');
    } else if (data.status === 403) {
      setShowPopup(true);
      setPopupType('403');
      setPopupMessage('Forbidden!');
    } else if (data.status === 404) {
      setShowPopup(true);
      setPopupType('404');
      setPopupMessage('Not Found!');
    } else if (data.status === 500) {
      setShowPopup(true);
      setPopupType('500');
      setPopupMessage('Internal Server Error!');
    } else {
      setShowPopup(true);
      setPopupType('unknown');
      setPopupMessage('Unknown error!');
    }
  } catch (error) {
    console.error('Failed to fetch:', error);

    if (attempt < RETRY_LIMIT) {
      setRetryCount(attempt + 1); // Increment retry count
      setTimeout(() => fetchItems(selectedItem,attempt + 1), 1000); // Retry after 1 second
    } else {
      setIsLoading(false);
      setPopupMessage('Internal Server Error. Kindly Retry.');
      setPopupType('500');
      setShowPopup(true);
      setRetryFunction(() => () => fetchItems(selectedItem,attempt)); // Set retry function
    }
  } finally {
    setIsLoading(false);
  }
};

  const handleProductClick = (product) => {
    if (!product || !product._id) {
      console.error("Invalid product or product ID");
      return;
    }
    console.log(product)
    setproductid(product._id);
    setSelectedProduct(product);
    getProductDetails(product._id)
    console.log(product)
    console.log(product._id)
    setProductLoader(true)
    setImageSrc(imageUrl + product?.product_image)
  };

  const getProductDetails = async (id, attempt = 1) => {
    if (!id) {
      console.error("Invalid product ID");
      return;
    }
  
    try {
          const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);

      const apiEndpoint = backendApiUrl + `product/get-product?id=${id}`; // Replace with your actual API endpoint
  
      // Make a GET request to the API
      const response = await fetch(apiEndpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
      });
  
      const data = await response.json();
      const output = await getResponseHandling(response, data);
      if (output) {
        setProductgroup(output?.productGroup);
        setproductData(output?.productData || []);
        const specifications = output?.productData?.specifications;
  
        let parsedSpecifications = [];
  
        if (typeof specifications === 'string' && specifications.trim() !== "") {
          try {
            // Parse the specifications
            const parsedData = JSON.parse(specifications);
  
            // Check if parsed data is an array
            if (Array.isArray(parsedData)) {
              // Filter out objects with no meaningful key-value pairs
              parsedSpecifications = parsedData.filter(spec => {
                // Check if the object is not empty and has at least one non-empty value
                if (typeof spec === 'object' && spec !== null) {
                  return Object.entries(spec).some(([key, value]) => 
                    value !== null && 
                    value !== undefined && 
                    value !== "" && 
                    (Array.isArray(value) ? value.length > 0 : true)
                  );
                }
                return false;
              });
            } else if (typeof parsedData === 'object' && parsedData !== null) {
              // If it's a single object, filter its key-value pairs
              const filteredSpec = Object.fromEntries(
                Object.entries(parsedData).filter(([key, value]) => 
                  value !== null && 
                  value !== undefined && 
                  value !== "" && 
                  (Array.isArray(value) ? value.length > 0 : true)
                )
              );
  
              // Only add to array if the filtered object is not empty
              if (Object.keys(filteredSpec).length > 0) {
                parsedSpecifications = [filteredSpec];
              }
            }
          } catch (error) {
            console.error("Error parsing specifications:", error);
            parsedSpecifications = [];
          }
        } else {
          parsedSpecifications = [];
        }
  
        // Ensure we always have an array, even if empty
        setSpecifications(parsedSpecifications);
  
        setvendor(output?.vendor);
        setProductCategory(output?.productCategory);
      } else {
        setProductgroup();
        setvendor();
        setProductCategory();
        setproductData([]);
      }
    } catch (error) {
      console.error('Failed to fetch:', error);
  
      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => getProductDetails(id, attempt + 1), 1000); // Retry after 1 second
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => getProductDetails(id, attempt)); // Set retry function
      }
    } finally {
      setProductLoader(false);
    }
  };

  const saveQuantityPricing = async () => {
    //console.log(quantityPricingRows)
    try {
      const InputData = {
        product_category_id: selectedProduct?.product_category_id?._id || null,
        product_sub_category_id: selectedProduct?.product_sub_category_id?._id || null,
        product_group_id: selectedProduct?.product_group_id?._id || null,
        product_id: selectedProduct?._id || null,
        moq_for_item_type : 'Product',
        moqs: quantityPricingRows.map(row => ({
          min_quantity: Number(row.minQuantity) || 0,
          max_quantity: Number(row.maxQuantity) || 0,
          selling_price: Number(row.sellingPrice) || 0,
          cost_price: Number(row.costPrice) || 0
        }))
      };
      console.log(backendApiUrl)
         const encryptedToken = sessionStorage.getItem('token');
             const token = decryptData(encryptedToken);

      console.log('token', token)
      const response = await fetch(backendApiUrl + 'moqs/create-update-moq', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
        body: JSON.stringify(InputData)
      });
      console.log(response)
      const data = await response.json();
      
      if (response.ok) {
        setShowPopup(true);
        setPopupType('200or201');
        setPopupMessage('MOQs saved successfully');
        setTimeout(() => {
          setPopupType(false)
          setPopupMessage('');
        }, 2000);
        setShowQuantityPricingPopup(false);
      } else {
        setShowPopup(true);
        setPopupType('400');
        setPopupMessage(data.message || 'Failed to save MOQs');
      }
    } catch (error) {
      console.error('Error saving MOQs:', error);
      setShowPopup(true);
      setPopupType('500');
      setPopupMessage('Internal Server Error. Please try again.');
    }
  };
  

  
  const getResponseHandling = async (response, data)=>{
    if (response.ok) {
      if (response.status === 200 || response.status === 201) {
        setPopupType('200or201');
          return (data.data)
      } else if (response.status === 204) {
        setPopupType('204');
        return (data.data)
      } 
    } else {
      if (response.status === 400) {
        setPopupType('400');
        setPopupMessage(data.message);
        setShowPopup(true);
        return null
      } else if (response.status === 401) {
        setPopupType('401');
        setPopupMessage(data.message);
        setShowPopup(true);
        return null
      } else if (response.status === 403) {
       
        setPopupType('403');
        setPopupMessage(data.message);
        setShowPopup(true);
        return null
      } else if (response.status === 500) {
       
        setPopupType('500');
        setPopupMessage(data.message);
        setShowPopup(true);
        return null
      } else {
        setErrorMessages([...errorMessages, data.message]);
      }
    }
  }
  const handleClose = () => {
    navigate(-1);
  }
   const handleClosePopup = ()=>{
    setShowRequiredPopup(false);
   }
  
   const HandleMoqs = async () =>{
    await getMOQsByProductGroupId(selectedProduct._id)
    setShowQuantityPricingPopup(true)
   }

   const getMOQsByProductGroupId = async (productId) => {
    try {
          const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);

      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}moqs/get-moq-by-product-id?product_id=${productId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      });
      const data = await response.json();
      console.log(data)
      if (data.status === 200) {
        setProductMoqsData(data.data);
        const MoqsData = data.data;
        const MoqsDataArray = Array.isArray(MoqsData.moqs) ? MoqsData.moqs.map(item => ({
          minQuantity : item.min_quantity,
          maxQuantity : item.max_quantity,
          sellingPrice: item.selling_price,
          costPrice: item.cost_price
        })) : [];
        console.log(MoqsDataArray)
        setQuantityPricingRows(MoqsDataArray || []);
      } else {
        setQuantityPricingRows([])
        console.error("Failed to fetch MOQs:", data.message);
      }
    } catch (error) {
      console.error("Error fetching MOQs:", error);
    }
  };

  if (isLoading) {
    return <Loader />;
  }
  
  const Retry = async() => {
    setTimeout(async ()=>{
      if(retryFunction){

        await retryFunction ();
      }

      setIsLoading(false)
    },1000)
    
    setShowPopup(false);
  };

  const handleDeleteItemImage = async (selectedItem) => {
        const encryptedToken = sessionStorage.getItem('token');
            const token = decryptData(encryptedToken);

  
    // Validate if necessary data is available
    if (!token) {
      console.error("Missing token or organizationId. Unable to proceed.");
      return;
    }
  
    try {
      // Construct the API URL with query parameters
      const url = new URL(`${process.env.REACT_APP_FORE_BRICKBUCKET}product/delete-product-image`);
  
      const itemdata = {
        _id: selectedItem._id,
        product_image: ''
      };
  
      // Make the API call
      const response = await fetch(url.toString(), {
        method: "PUT",
        headers: {
          'Content-Type': 'application/json',
          "x-token": token,
        },
        body: JSON.stringify(itemdata)
      });
  
      // Check response status before parsing
      if (!response.ok) {
        const errorText = await response.text();
        console.error("Server error:", errorText);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      // Parse the response
      const data = await response.json();
  
      // Check if the status is successful
      if (data.status === 200) {
        handleUpdateTheImageDataInItem(selectedItem);
      } else {
        console.error("Failed to delete image:", data.message || "Unknown error.");
      }
    } catch (error) {
      // Catch any network or unexpected errors
      console.error("Error while deleting image:", error.message);
    }
  };
  
  
  const handleUpdateTheImageDataInItem = (selectedItem) => {
    try {
      // Validate input
      if (!selectedItem || !selectedItem._id) {
        console.error('Invalid item: Missing _id');
        return;
      }
  
      // Create a new item object with updated image
      const updatedItem = {
        ...selectedItem,
        product_image: ""
      };
  
      // Update the selected product state
      setSelectedProduct((prevProduct) => {
        // Ensure we're updating the correct product
        if (prevProduct?._id !== selectedItem._id) {
          console.warn('Attempted to update a different product');
          return prevProduct;
        }
        
        return {
          ...prevProduct,
          product_image: ""
        };
      });
  
      // Fetch items with error handling
      const fetchItemsWithErrorHandling = async () => {
        try {
          await fetchItems(updatedItem);
        } catch (fetchError) {
          console.error('Error fetching items after image deletion:', fetchError);
          // Optional: Show user-friendly error notification
          // setErrorMessage('Failed to update item. Please try again.');
        }
      };
  
      // Call the fetch function
      fetchItemsWithErrorHandling();
  
    } catch (error) {
      console.error('Comprehensive error in handleUpdateTheImageDataInItem:', {
        message: error.message,
        stack: error.stack,
        item: selectedItem
      });
  
      // Optional: Implement error tracking or reporting
      // errorTrackingService.report(error);
    }
  };
  
  

  const BackToLoginPage = () => {
    setShowPopup(false);
    localStorage.removeItem('LoginData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('appId');
  navigate('/bb');
    };

    // Add this function to handle input changes in the quantity pricing table
const handleQuantityPricingChange = (index, field, value) => {
  const updatedRows = [...quantityPricingRows];
  updatedRows[index][field] = value;
  setQuantityPricingRows(updatedRows);
};

// Add this function to add a new row to the quantity pricing table
const addQuantityPricingRow = () => {
  setQuantityPricingRows([
    ...quantityPricingRows, 
    { minQuantity: '', maxQuantity: '', sellingPrice: '', costPrice: '' }
  ]);
};

// Add this function to delete a row from the quantity pricing table
const deleteQuantityPricingRow = (index) => {
  const updatedRows = [...quantityPricingRows];
  updatedRows.splice(index, 1);
  setQuantityPricingRows(updatedRows);
};

// Add this function to save the quantity pricing data
/* const saveQuantityPricing = () => {
  
  setShowQuantityPricingPopup(false);
}; */


    const closePopup = () => {
      setShowPopup(false);
    };

    const handleCreateItem = () => {
      navigate('/bb/app/items/newitem');
    }

    const handleEditItem = () => {
      setSearchQuery('');  
  setSearchType('');
      navigate('/bb/app/items/edititems', { state: { ItemData: selectedProduct } });
    }


  




const handleSearch = ({ query, type }) => {
  if (!query?.trim() || !type) return;
  // New: Directly set single query and type (no array)
  setSearchQuery(query.trim());
  setSearchType(type);
};

  return (

    <div className=" bg-white flex flex-row w-full justify-center overflow-y-hidden">
      {/* List of Customers Div start */}
      <div className=" flex flex-col  w-[32%]  ">
  <div className="p-4 border-b  flex flex-row justify-between ">
      <div>
      <h5 className="text-md font-semibold cursor-pointer ">All Items
       <FontAwesomeIcon icon={faChevronDown} className="text-xs mb-0.5 text-blue-600 mx-1 cursor-pointer " />
      </h5>
      </div>
      <div className=''>
      <button onClick={handleCreateItem}
    className="mr-2 bg-[#f7525a] text-white px-1 py-0.5 rounded-md" 
     title="" data-tooltip="Create Item"  style={{ '--tooltip-bg': 'black' }}>
    <FontAwesomeIcon icon={faPlus} className="mb-0.5 text-xs text-white mx-1 cursor-pointer" />
  </button>
  </div>
    </div>
    <div className='flex justify-center items-center mt-2 pb-2 px-3 border-b'>
      <div className="mx-auto">
    
<Search
  searchQuery={searchQuery}
  setSearchQuery={setSearchQuery}
  searchType={searchType}
  setSearchType={setSearchType}
  searchTypes={searchTypes}
  placeholder="Search item details..."
  onSearch={handleSearch}          
  onSearchSubmit={handleSearch}    
/>
</div>
  </div>

  <div className=" flex justify-center  overflow-y-hidden  flex-col ">
   <div className='flex  flex-col h-[80vh]  overflow-y-auto pb-10' 
     ref={listContainerRef}>

       {searchQuery && itemsToDisplay.length === 0 && (
    <div className="flex justify-center items-center py-10">
    <div className="flex flex-col items-center text-gray-500">
  <FontAwesomeIcon
    icon={faSearch}
    className="text-2xl mb-2"
  />
  <p className="text-sm">No Results Found</p>
</div>
    </div>
  )}

   {itemsToDisplay.map((product) => (
        <div
          key={product._id}
         ref={(el) => (itemRefs.current[product._id] = el)}
          onClick={() => handleProductClick(product)}
          className={` border-b text-sm flex items-center px-4 py-2 ${selectedProduct?._id === product._id ? 'bg-gray-100' : ''} hover:bg-gray-100 cursor-pointer`}
        >
          <div className='w-full flex flex-row justify-between'>
            <div className='w-[10%]'>
              <input type="checkbox" className="mr-2 border border-gray-400 shadow-sm hover:shadow-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-600 rounded" />
            </div>
            <div className='w-[80%] flex flex-col'>
              <div>
              <p className='text-xs font-semibold pr-4 ' >{product.product_name}</p>
              </div>
              {product?.UOM_id && (
  <div className='text-gray-800 mt-2 flex flex-row'>
    <p className='text-xs mr-1'>Units : </p>
    <p className='text-xs'>{product.UOM_id.UOM}</p>
  </div>
)}
            </div>
            {product?.selling_price && (
            <div className='w-[10%] flex justify-end'> 
                <p className='text-md font-semibold' >₹{product.selling_price.toLocaleString()}</p>
              </div>
            )}
          </div>
        </div>
      ))}
  </div>
</div>
</div>
{/* List of Customers Div end */}

<div className="border-l w-full flex flex-col">
      {selectedProduct ? (
        <>
          <div className="border-b h-20 overflow-hidden"> {/* or h-12, depending on your desired height */}
            <div className='p-4 flex justify-between items-center relative'>
              <span className="text-md font-semibold">{selectedProduct?.product_name}</span>
              <div className="flex items-center space-x-2 px-2">
  <button
    type="button"
    onClick={() => HandleMoqs()}
    className="px-3 py-1 bg-white text-blue-600 border border-blue-500 rounded-md text-sm flex items-center hover:bg-blue-50 transition-colors duration-200"
  >
    <FontAwesomeIcon icon={faPlusCircle} className="mr-2 text-blue-500" />
    MOQs
  </button>
  
  <button 
    className="px-3 py-1 bg-gray-100 text-gray-700 border border-gray-300 rounded-md text-sm hover:bg-gray-200 transition-colors duration-200"
    onClick={handleEditItem}
  >
    Edit
  </button>
  
  {/* Uncomment if needed
  <button className="px-3 py-1 bg-gray-100 text-gray-700 border border-gray-300 rounded-md text-sm flex items-center hover:bg-gray-200 transition-colors duration-200">
    <FontAwesomeIcon icon={faPaperclip} className="mr-2" />
    Attach
  </button>
  
  <button className="px-3 py-1 bg-[#f7525a] text-white border border-[#f7525a] rounded-md text-sm hover:bg-[#e54643] transition-colors duration-200">
    New Transaction
  </button>
  
  <button
    className="px-3 py-1 bg-gray-100 text-gray-700 border border-gray-300 rounded-md text-sm hover:bg-gray-200 transition-colors duration-200"
    onClick={() => setShowRequiredPopup(!showRequiredPopup)}
  >
    Assign
  </button>
  */}
  
  <button 
    className="p-1 text-[#f7525a] hover:text-[#e54643] transition-colors duration-200 rounded-md"
    onClick={handleClose}
    title="Close"
  >
    <FontAwesomeIcon icon={faX} className="text-md" />
  </button>
</div>

            </div>
          </div>
          {ProductLoader ? (
    <Loader />
  ) : (
          <div className="h-5/6 w-full flex justify-center">
            <div className="flex flex-row h-full w-full">
              <div className="flex flex-1 h-full flex-col">
      <div className="flex flex-col h-[80vh] overflow-y-auto bg-white ">
  
  

  <div className="p-4 space-y-6">

  <section>
  {/* Header - Matching style */}
   <div className="flex items-center gap-3 mb-4">
        <h3 className="text-md text-[1rem] font-semibold">Item Specifications</h3>
        </div>

  {specifications?.length > 0 ? (
    /* Integrated Single Container */
<div className="w-fit min-w-[280px] max-w-xl bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm">
        <div className="flex flex-col">
        {specifications.map((spec) => 
          Object.entries(spec).map(([key, value], entryIdx) => (
     <div
  key={key}
  className={`grid grid-cols-[140px,minmax(0,1fr)] gap-4 px-5 py-2 ${
    entryIdx !== Object.entries(spec).length - 1 ? "border-b border-gray-100" : ""
  }`}
>
  {/* Key */}
  <span className="text-sm leading-none">
    {key.replace(/_/g, " ")}
  </span>

  {/* Value */}
  <span className="text-sm font-medium  break-words leading-none">
    {String(value)}
  </span>
</div>
          ))
        )}
      </div>
    </div>
  ) : (
    <div className="py-3 px-4 border border-dashed border-gray-200 rounded-xl bg-gray-50/30">
      <span className="text-xs text-gray-400"> No specifications currently assigned to this item. Please assign specifications if needed.</span>
    </div>
  )}
</section>
    
    {/* 2. DESCRIPTION SECTION (Full Vertical) */}
 <section>
  <div className="flex items-center gap-3 mb-4">
    <h3 className="text-md text-[1rem] font-semibold">Item Category Details</h3>
    {/* <div className="h-[1px] flex-1 bg-gray-100"></div> */}
  </div>
  {/* Main Unified Container */}
  <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
    <div className="flex flex-col p-4 space-y-2">
      
      {/* Row 1: Category with large gap */}
      <div className="flex flex-row items-start gap-16">
          <span className="text-sm">
            Category
          </span>
  
        
        {/* The "Gap" is handled by justify-between */}
        <div className="flex items-center gap-2">
          {/* <div className="w-1.5 h-1.5 bg-blue-500 rounded-full"></div> */}
          <span className="text-sm font-bold text-gray-800">
            {productCategory?.category_name || "Uncategorized"}
          </span>
      </div>
      </div>

      {/* Row 2: Description with Border Box */}
      <div className="flex flex-row items-start gap-12 py-1">
  {/* Label - Fixed width ensures alignment */}
  <span className="text-sm mt-2">
    Description
  </span>

  {/* Description Border Box - Takes remaining space */}
  <div className="flex-1 min-w-0 w-52 bg-white border border-gray-200 rounded-lg px-3 py-2 text-left">
    <p className="text-xs text-gray-600 items-start  break-words ">
      {selectedProduct?.product_description || "descrption not avaible for this item."}
    </p>
  </div>
</div>

    </div>
  </div>
</section>

    {/* 3. PRICING & LIMITS SECTION (Full Vertical) */}
   <div className="space-y-10">
  {/* SECTION 1: PURCHASE & SALES ROW */}
  <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
    {/* Purchase Info */}
    <section className="flex flex-col">
        <div className="flex items-center gap-3 mb-4">
      <h3 className="text-md text-[1rem] font-semibold">
        Purchase Information
      </h3>
      </div>
      <div className="flex items-center justify-between p-5 bg-white border border-gray-200 rounded-2xl shadow-sm hover:shadow-md transition-shadow">
        <div className="flex items-center gap-4">
          <div className="w-8 h-8 bg-blue-50 text-blue-600 rounded-xl flex items-center justify-center text-lg">
            💳
          </div>
          <span className="text-sm">Cost Price</span>
        </div>
        <span className="text-lg font-black text-gray-900">
          ₹{selectedProduct?.cost_price?.toLocaleString()}
        </span>
      </div>
    </section>

    {/* Sales Info */}
    <section className="flex flex-col">
        <div className="flex items-center gap-3 mb-4">
      <h3 className="text-md text-[1rem] font-semibold">
        Sales Information
      </h3>
      </div>
      <div className="flex items-center justify-between p-5 bg-white border border-gray-200 rounded-2xl shadow-sm hover:shadow-md transition-shadow">
        <div className="flex items-center gap-4">
          <div className="w-8 h-8 bg-emerald-50 text-emerald-600 rounded-xl flex items-center justify-center text-lg">
            💰
          </div>
          <span className="text-sm "> Selling Price</span>
        </div>
        <span className="text-lg font-black text-emerald-600">
          ₹{selectedProduct?.selling_price?.toLocaleString()}
        </span>
      </div>
    </section>
  </div>

  {/* SECTION 2: MARKET & QUANTITY ROW */}
  <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
    {/* Market Price Range */}
    <section className="flex flex-col">
        <div className="flex items-center gap-3 mb-4">
      <h3 className="text-md text-[1rem] font-semibold">
        Market Price Range
      </h3>
      </div>
      <div className="grid grid-cols-2 gap-0 bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">
        <div className="p-5 border-r border-gray-100 flex flex-col items-center justify-center text-center">
          <span className="text-sm mb-1">Minimum</span>
          <span className="text-sm font-black text-gray-800">₹{selectedProduct?.market_range?.min || 0}</span>
        </div>
        <div className="p-5 flex flex-col items-center justify-center text-center">
          <span className="text-sm  mb-1">Maximum</span>
          <span className="text-sm font-black text-gray-800">₹{selectedProduct?.market_range?.max || 0}</span>
        </div>
      </div>
    </section>

    {/* Quantity Limits */}
    <section className="flex flex-col">
        <div className="flex items-center gap-3 mb-4">
      <h3 className="text-md text-[1rem] font-semibold">
        Quantity Limits
      </h3>
      </div>
      <div className="grid grid-cols-2 gap-0 bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">
        <div className="p-5 border-r border-gray-100 flex flex-col items-center justify-center text-center">
          <span className="text-sm  mb-1">Minimum</span>
          <span className="text-sm font-black text-gray-800">{selectedProduct?.quantity_limits?.min || 0}</span>
        </div>
        <div className="p-5 flex flex-col items-center justify-center text-center">
          <span className="text-sm mb-1">Maximum</span>
          <span className="text-sm font-black text-gray-800">{selectedProduct?.quantity_limits?.max || 0}</span>
        </div>
      </div>
    </section>
  </div>
</div>

  
     <section>
  <div className="flex items-center gap-3 mb-4">
    <h3 className="text-md text-[1rem] font-semibold">
      Alternative Names
    </h3>
    {/* <div className="h-[1px] flex-1 bg-gray-100"></div> */}
  </div>

  {selectedProduct?.alternate_names && selectedProduct.alternate_names.length > 0 ? (
    <div className="flex flex-wrap gap-2">
      {selectedProduct.alternate_names.map((name, i) => (
        <span 
          key={i} 
          className="px-4 py-2 bg-gray-100  rounded-lg text-xs font-medium tracking-wider shadow-sm"
        >
          {name}
        </span>
      ))}
    </div>
  ) : (
    /* Message displayed when no names are found */
    <div className="flex items-center gap-2 px-4 py-3 bg-gray-50 border border-dashed border-gray-200 rounded-xl">
      <span className="text-gray-400 text-xs ">
        No alternative names found for this item.
      </span>
    </div>
  )}
</section>

<section>
  <div className="flex items-center gap-3 mb-4">
    <h3 className="text-md text-[1rem] font-semibold">Vendor Details</h3>
  </div>

  {vendor ? (
    <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm transition-all">
      <div className="flex gap-5">
        
        {/* Left Side: Initial Avatar */}
        <div className="w-14 h-14 bg-slate-50 border border-slate-100 text-slate-600 rounded-xl flex-shrink-0 flex items-center justify-center font-bold text-xl shadow-sm">
          {vendor.vendor_name?.charAt(0)}
        </div>

        {/* Right Side: Details Content */}
        <div className="flex-1 flex flex-col gap-2">
          
          {/* Vendor Name (Representative) */}
          <div>
            <h4 className="text-md font-semibold leading-tight">
              {vendor.vendor_name}
            </h4>
          </div>

          {/* Company Name Row */}
       <div className="flex items-center gap-2">
  <span className="text-gray-400 text-sm">🏢</span>

  <span className="text-sm font-semibold text-blue-600 tracking-tight">
    {vendor.vendor_company}
  </span>
</div>

          {/* Conditional Address Row - Only renders if data exists */}
{vendor.vendor_address && vendor.vendor_address.trim() !== "" && (
              <div className="flex items-start gap-2 border-t border-gray-50">
<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="text-blue-500 font-bold mt-1">
  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
  <circle cx="12" cy="10" r="3"></circle>
</svg>
              
                     <div className="flex flex-col">
                {/* <span className="text-sm">Address</span> */}
                <p className="text-sm leading-relaxed max-w-xs">
                  {vendor.vendor_address}
                </p>
              </div>
            </div>
          )}

          {/* Conditional Pincode Row - Only renders if data exists */}
          {vendor.vendor_pincode && (
            <div className="flex items-center gap-2">
<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="text-red-500 font-bold ">
  <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
  <line x1="7" y1="7" x2="7.01" y2="7"></line>
</svg>    

          <div className="flex items-center gap-2">
                {/* <span className="text-sm">Pincode</span> */}
                <span className="text-sm font-medium">
                  {vendor.vendor_pincode}
                </span>
              </div>
            </div>
          )}
          
        </div>
      </div>
    </div>
  ) : (
    /* Consistent "No Data" state */
    <div className="py-5 text-center border border-dashed border-gray-200 rounded-2xl bg-gray-50/30">
      <span className="text-xs text-gray-400 italic">No vendor assigned to this item.</span>
    </div>
  )}
</section>
  

  </div>
</div>
              </div>

<div className="flex w-60 h-full p-4 mt-4 justify-center">
  <div 
    className="flex flex-col h-48 justify-center p-1 w-40  border  border-dashed border-gray-300 rounded-lg transition-colors"
    onDragOver={handleDragOver}
    onDragLeave={handleDragLeave}
    onDrop={handleDrop}
    onClick={() => document.getElementById("imageInput").click()}
  >
    <div className="flex justify-center">
         {imageSrc && selectedProduct.product_image ? (
        <img
          src={imageSrc}
          alt={selectedProduct.product_image}
          className="flex w-28 h-28 object-cover rounded-lg"
        />
      ) : (
        <div className="flex w-28 h-28 bg-gray-100 rounded-lg items-center justify-center">
          <FontAwesomeIcon 
            icon={faImage} 
            className="text-gray-400 text-3xl" 
          />
        </div>
      )}
    </div>
    <div className="mt-6 flex justify-between">
         <input
      type="file"
      id="imageInput"
      style={{ display: 'none' }}
      accept="image/*"
      onChange={handleImageChange}
       onClick={handleFileInputClick}
    />
    <div className="text-center text-xs text-gray-400">
      Click or drag to upload
    </div>
      <FaRegTrashAlt 
        className="text-xs text-gray-600 mx-1 cursor-pointer" 
        onClick={(e) => {
          e.stopPropagation(); 
          handleDeleteItemImage(selectedProduct);
        }}
      />
    </div>
 
  </div>
  {isUploading && <p>Uploading...</p>}
</div>

            </div>
          </div>     
  )}
        </>
      ) : (
        <div className="flex justify-center items-center h-full">
          <p className="text-gray-500">Select an Item to view details</p>
        </div>
      )}
  
</div>


{showPopup && (
  <div>
    {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
    {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
    {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
          {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup}/>}
  </div>
)}

{/* {showRequiredPopup && (
  <div className="fixed z-20 inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50">
    <div className="bg-white rounded-b-md shadow-md w-1/2 h-2/3 flex flex-col ">
      <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-[10%] px-6'>
        <h2 className="text-md"> Attributes</h2>
        <button onClick={handleClosePopup} className="text-white px-1 py-1 rounded-md ">   
          <FontAwesomeIcon icon={faX} className="text-xs text-[#e54643] cursor-pointer " />
        </button>
      </div>
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      {attributeLoading ?(
          <>
          <Loader />
          </>
      ):(

     <>
      <div className="w-full flex flex-row items-center justify-center mb-4 space-x-2 mt-5 px-6">
         <label htmlFor="uom" className="block text-sm font-regular text-[#e54643] w-1/6">
          Attributes<span className="text-red-500">*</span>
        </label> 
        
      </div>

      <div className="w-full flex flex-row justify-center items-center mb-4 space-x-2 px-6">
      <div className="flex justify-center flex-col items-center">
        
      </div>
      </div>
      <div className="mt-auto w-full">
        <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
        <div className="flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
          <button className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md"
            onClick={handleAddattributesToGroup} >
            Save {isSaving && (
          <Spinner/>)}
            </button>
          <button onClick={handleClosePopup} className="px-2 py-1 bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD] rounded-md">Cancel</button>
        </div>
      </div>
      </>
 )}
    </div>
  </div>
)} */}

       {showQuantityPricingPopup && (
  <div className="fixed inset-0 z-50 flex items-top justify-center bg-gray-800 bg-opacity-50">
    <div className="bg-white rounded-b-md shadow-md w-3/4 h-3/4 flex flex-col animate-slide-in">
      <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-[10%] px-6'>
        <h2 className="text-md font-semibold">Quantity-based Pricing</h2>
        <button onClick={() => setShowQuantityPricingPopup(false)} className="text-white px-1 py-1 rounded-md">   
          <FontAwesomeIcon icon={faX} className="text-xs text-[#e54643] cursor-pointer" />
        </button>
      </div>
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      
      <div className="flex-grow overflow-auto p-6">
        <table className="w-full border-collapse">
          <thead>
            <tr className="text-[#6c7184] bg-[#fafafc]">
              <th className="font-semibold text-left text-sm py-2 px-4 border">Min Quantity</th>
              <th className="font-semibold text-left text-sm py-2 px-4 border">Max Quantity</th>
              <th className="font-semibold text-left text-sm py-2 px-4 border">Selling Price</th>
              <th className="font-semibold text-left text-sm py-2 px-4 border">Cost Price</th>
              <th className="font-semibold text-left text-sm py-2 px-4 border">Actions</th>
            </tr>
          </thead>
          <tbody>
            {quantityPricingRows.map((row, index) => (
              <tr key={index}>
                <td className="border p-2">
                  <input
                    type="number"
                    value={row.minQuantity}
                    onChange={(e) => handleQuantityPricingChange(index, 'minQuantity', e.target.value)}
                    className="outline-blue-500 text-sm w-full p-2 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
                    placeholder="Min"
                  />
                </td>
                <td className="border p-2">
                  <input
                    type="number"
                    value={row.maxQuantity}
                    onChange={(e) => handleQuantityPricingChange(index, 'maxQuantity', e.target.value)}
                    className="outline-blue-500 text-sm w-full p-2 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
                    placeholder="Max"
                  />
                </td>
                <td className="border p-2">
                  <input
                    type="number"
                    value={row.sellingPrice}
                    onChange={(e) => handleQuantityPricingChange(index, 'sellingPrice', e.target.value)}
                    className="outline-blue-500 text-sm w-full p-2 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
                    placeholder="Selling Price"
                  />
                </td>
                <td className="border p-2">
                  <input
                    type="number"
                    value={row.costPrice}
                    onChange={(e) => handleQuantityPricingChange(index, 'costPrice', e.target.value)}
                    className="outline-blue-500 text-sm w-full p-2 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
                    placeholder="Cost Price"
                  />
                </td>
                <td className="border p-2">
                  {quantityPricingRows.length > 1 && (
                    <button
                      type="button"
                      onClick={() => deleteQuantityPricingRow(index)}
                      className="text-red-500 hover:text-red-700"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        
        <div className="mt-4">
          <button
            onClick={addQuantityPricingRow}
            className="text-blue-500 py-2 px-4 hover:text-blue-700"
          >
            <FontAwesomeIcon icon={faPlusCircle} className="mr-2" />
            Add Row
          </button>
        </div>
      </div>
      
      <div className="mt-auto w-full">
        <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
        <div className="flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
          <button 
            className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md"
            onClick={saveQuantityPricing}
          >
            Save
          </button>
          <button 
            onClick={() => setShowQuantityPricingPopup(false)} 
            className="px-2 py-1 bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD] rounded-md"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
)}
             


    </div>

  );

};



export default ViewProductDetails;